import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

const followingAccountsData = [
  {
    id: 1,
    name: "Nykaa",
    followers: "27,200 Followers",
    image: "https://via.placeholder.com/48x48.png?text=N",
  },
  {
    id: 2,
    name: "Sugar",
    followers: "1100 Followers",
    image: "https://via.placeholder.com/48x48.png?text=S",
  },
  {
    id: 3,
    name: "Biotique",
    followers: "93,200 Followers",
    image: "https://via.placeholder.com/48x48.png?text=B",
  },
  {
    id: 4,
    name: "VLCC",
    followers: "5.3M+ Followers",
    image: "https://via.placeholder.com/48x48.png?text=V",
  },
  {
    id: 5,
    name: "Mamaearth",
    followers: "1.2M Followers",
    image: "https://via.placeholder.com/48x48.png?text=M",
  },
  {
    id: 6,
    name: "Lakme",
    followers: "800K Followers",
    image: "https://via.placeholder.com/48x48.png?text=L",
  },
];

const suggestedAccountsData = [
  {
    id: 1,
    name: "Nykaa",
    followers: "27,200 Followers",
    image: "https://via.placeholder.com/48x48.png?text=N",
  },
  {
    id: 2,
    name: "Nykaa",
    followers: "27,200 Followers",
    image: "https://via.placeholder.com/48x48.png?text=N",
  },
  {
    id: 3,
    name: "Nykaa",
    followers: "27,200 Followers",
    image: "https://via.placeholder.com/48x48.png?text=N",
  },
  {
    id: 4,
    name: "Nykaa",
    followers: "27,200 Followers",
    image: "https://via.placeholder.com/48x48.png?text=N",
  },
];

function AccountRow({ account, buttonText, buttonVariant = "outlined" }) {
  const isFilled = buttonVariant === "contained";

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 2,
          px: 1,
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Avatar
            src={account.image}
            alt={account.name}
            sx={{ width: 48, height: 48 }}
          />
          <Box>
            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 600,
                color: "#111",
                lineHeight: 1.2,
              }}
            >
              {account.name}
            </Typography>
            <Typography
              sx={{
                fontSize: "1.2rem",
                color: "#6b7280",
                mt: 0.3,
              }}
            >
              {account.followers}
            </Typography>
          </Box>
        </Stack>

        <Button
          variant={buttonVariant}
          sx={{
            minWidth: 110,
            height: 40,
            borderRadius: "10px",
            textTransform: "none",
            fontSize: "1rem",
            fontWeight: 500,
            boxShadow: "none",
            ...(isFilled
              ? {
                  backgroundColor: "#000",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#111",
                    boxShadow: "none",
                  },
                }
              : {
                  borderColor: "#e5e7eb",
                  color: "#6b7280",
                  backgroundColor: "#fff",
                  "&:hover": {
                    borderColor: "#d1d5db",
                    backgroundColor: "#fafafa",
                  },
                }),
          }}
        >
          {buttonText}
        </Button>
      </Box>
      <Divider />
    </>
  );
}

export default function Following() {
  const [showAll, setShowAll] = useState(false);

  const initialVisibleCount = 4;
  const visibleFollowingAccounts = showAll
    ? followingAccountsData
    : followingAccountsData.slice(0, initialVisibleCount);

  return (
    <Box
      sx={{
        maxWidth: 760,
        width: "100%",
        margin: "0 auto",
        backgroundColor: "#fff",
      }}
    >
      {/* First Section */}
      <Box>
        {visibleFollowingAccounts.map((account) => (
          <AccountRow
            key={account.id}
            account={account}
            buttonText="Following"
            buttonVariant="outlined"
          />
        ))}

        {followingAccountsData.length > initialVisibleCount && (
          <Box
            sx={{
              py: 1.5,
              display: "flex",
              justifyContent: "center",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <Button
              onClick={() => setShowAll((prev) => !prev)}
              sx={{
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 600,
                color: "#111",
              }}
            >
              {showAll ? "Show less" : "Show more"}
            </Button>
          </Box>
        )}
      </Box>

      {/* Suggested Accounts */}
      <Box sx={{ pt: 4 }}>
        <Typography
          sx={{
            px: 1,
            pb: 2,
            fontSize: "1.75rem",
            fontWeight: 700,
            color: "#111",
          }}
        >
          Suggested Accounts
        </Typography>

        {suggestedAccountsData.map((account) => (
          <AccountRow
            key={account.id}
            account={account}
            buttonText="Follow"
            buttonVariant="contained"
          />
        ))}
      </Box>
    </Box>
  );
}